import CardSwitch from './card-switch';

export default CardSwitch;
